import React, { Fragment } from 'react';
import { ArrowRight } from 'lucide-react';
interface HeroSectionProps {
  'data-id'?: string;
}
export function HeroSection({
  'data-id': dataId
}: HeroSectionProps) {
  return <div className="w-full bg-white relative overflow-hidden" data-id="element-171">
      {/* Header */}
      <header className="relative z-10" data-id="element-172">
        <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global" data-id="element-173">
          <div className="flex lg:flex-1" data-id="element-174">
            <a href="#" className="-m-1.5 p-1.5" data-id="element-175">
              <span className="sr-only" data-id="element-176">Naiomi AI</span>
              <div className="flex items-center" data-id="element-177">
                {/* Logo image */}
                <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/09/FF_NAIOMI.png" alt="Naiomi AI Logo" className="h-16 w-auto" data-id="element-178" />
              </div>
            </a>
          </div>
          {/* Navigation links - hidden on mobile, visible on medium screens and up */}
          <div className="flex items-center gap-x-6" data-id="element-179">
            <a href="#waitlist" className="hidden md:block rounded-md bg-benetton-blue px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-benetton-blue/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-benetton-blue font-jakarta" data-id="element-180">
              Join the Waitlist
            </a>
          </div>
        </nav>
      </header>
      {/* Hero content */}
      <div className="relative isolate px-6 pt-4 pb-64 lg:px-8 z-10" data-id="element-181">
        {/* Background pattern that bleeds into adjacent sections */}
        <div className="absolute inset-0 -top-24 -bottom-48 left-0 right-0 z-0 pointer-events-none overflow-hidden" data-id="element-182">
          {/* Racing checkered flag pattern with Benetton-inspired accents */}
          <div className="absolute inset-0 opacity-[0.16]" data-id="element-183">
            <div className="absolute inset-0 overflow-hidden" data-id="element-184">
              {/* Checkered pattern grid */}
              <div className="absolute inset-0 grid" style={{
              gridTemplateColumns: 'repeat(20, 1fr)',
              gridTemplateRows: 'repeat(30, 3.5vw)'
            }} data-id="element-185">
                {Array.from({
                length: 600
              }).map((_, index) => {
                const row = Math.floor(index / 20);
                const col = index % 20;
                const isCheckered = row % 2 === 0 && col % 2 === 0 || row % 2 === 1 && col % 2 === 1;
                // Enhanced Benetton color accents at specific intervals
                let accentColor = '';
                if (col === 1 || col === 19) accentColor = 'bg-benetton-red';else if (col === 3 || col === 17) accentColor = 'bg-benetton-orange';else if (col === 5 || col === 15) accentColor = 'bg-benetton-yellow';else if (col === 7 || col === 13) accentColor = 'bg-benetton-lightGreen';else if (col === 9 || col === 11) accentColor = 'bg-benetton-blue';else if (col === 0 && row % 5 === 0) accentColor = 'bg-benetton-violet';else if (col === 10 && row % 7 === 0) accentColor = 'bg-benetton-magenta';else if (col === 20 && row % 4 === 0) accentColor = 'bg-benetton-teal';
                return <div key={index} className={`${isCheckered ? 'bg-black' : 'bg-white'} ${accentColor} opacity-25`} style={{
                  gridColumn: `${col + 1} / span 1`,
                  gridRow: `${row + 1} / span 1`,
                  transform: `skewY(-2deg) ${Math.random() > 0.95 ? 'scale(1.2)' : ''}`
                }} data-id="element-186"></div>;
              })}
              </div>
              {/* Dynamic racing stripes with enhanced Benetton colors */}
              <div className="absolute inset-0" data-id="element-187">
                <div className="absolute top-1/5 left-0 right-0 h-[3px] bg-benetton-green opacity-40 transform -skew-y-6" data-id="element-188"></div>
                <div className="absolute top-1/4 left-0 right-0 h-[3px] bg-benetton-blue opacity-40 transform -skew-y-6" data-id="element-189"></div>
                <div className="absolute top-1/3 left-0 right-0 h-[3px] bg-benetton-red opacity-40 transform skew-y-3" data-id="element-190"></div>
                <div className="absolute top-2/5 left-0 right-0 h-[3px] bg-benetton-orange opacity-35 transform -skew-y-9" data-id="element-191"></div>
                <div className="absolute top-1/2 left-0 right-0 h-[3px] bg-benetton-violet opacity-30 transform skew-y-12" data-id="element-192"></div>
                <div className="absolute top-3/5 left-0 right-0 h-[3px] bg-benetton-yellow opacity-40 transform -skew-y-3" data-id="element-193"></div>
                <div className="absolute top-2/3 left-0 right-0 h-[3px] bg-benetton-magenta opacity-35 transform -skew-y-12" data-id="element-194"></div>
                <div className="absolute top-4/5 left-0 right-0 h-[3px] bg-benetton-teal opacity-40 transform skew-y-9" data-id="element-195"></div>
                <div className="absolute bottom-1/4 left-0 right-0 h-[3px] bg-benetton-darkGreen opacity-30 transform skew-y-6" data-id="element-196"></div>
              </div>
              {/* Diagonal color accents */}
              <div className="absolute inset-0" data-id="element-197">
                <div className="absolute top-0 left-1/4 w-[3px] h-full bg-benetton-red opacity-20 transform rotate-12" data-id="element-198"></div>
                <div className="absolute top-0 left-1/3 w-[3px] h-full bg-benetton-yellow opacity-15 transform -rotate-6" data-id="element-199"></div>
                <div className="absolute top-0 left-2/3 w-[3px] h-full bg-benetton-blue opacity-20 transform rotate-9" data-id="element-200"></div>
                <div className="absolute top-0 right-1/4 w-[3px] h-full bg-benetton-green opacity-15 transform -rotate-12" data-id="element-201"></div>
              </div>
            </div>
            {/* Fade gradients */}
            <div className="absolute top-0 left-0 right-0 h-64 bg-gradient-to-b from-white to-transparent" data-id="element-202"></div>
            <div className="absolute bottom-0 left-0 right-0 h-[16rem] bg-gradient-to-t from-white via-white/90 to-transparent" data-id="element-203"></div>
          </div>
        </div>
        <div className="mx-auto max-w-4xl py-6 sm:py-8 lg:py-10 relative z-10" data-id="element-204">
          <div className="text-center" data-id="element-205">
            <h1 className="text-5xl font-normal tracking-tight text-benetton-green sm:text-6xl font-apercu" data-id="element-206">
              Turn Fragmented eCommerce Data Into Actionable Insights
            </h1>
            <p className="mt-10 text-lg leading-8 text-gray-600 max-w-3xl mx-auto font-jakarta" data-id="element-207">
              Connect your entire eCommerce tech stack and unlock powerful
              insights that drive smarter decisions, stronger customer
              relationships, and sustainable growth.{' '}
            </p>
            <div className="flex flex-wrap justify-center items-center gap-8 sm:gap-12 mt-12" data-id="element-208">
              <span className="flex items-center py-2 font-jakarta" data-id="element-209">
                <span className="w-5 h-5 bg-benetton-red rounded-full mr-3 flex-shrink-0" data-id="element-210"></span>
                Connect Your Apps
              </span>
              <span className="flex items-center py-2 font-jakarta" data-id="element-211">
                <span className="w-5 h-5 bg-benetton-orange rounded-full mr-3 flex-shrink-0" data-id="element-212"></span>
                Ask Any Question
              </span>
              <span className="flex items-center py-2 font-jakarta" data-id="element-213">
                <span className="w-5 h-5 bg-benetton-green rounded-full mr-3 flex-shrink-0" data-id="element-214"></span>
                Get Instant Insights
              </span>
            </div>
            <div className="mt-16 flex items-center justify-center" data-id="element-215">
              <a href="#waitlist" className="rounded-lg bg-benetton-blue px-6 py-3 text-lg font-semibold text-white shadow-sm hover:bg-benetton-blue/80 transition-colors" data-id="element-216">
                Join the Waitlist
              </a>
            </div>
          </div>
        </div>
        {/* Logo Section - Moved from ProblemSection */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8 relative z-10" data-id="element-217">
          <div className="text-center mb-6" data-id="element-218">
            <p className="text-lg text-benetton-green font-medium font-jakarta" data-id="element-219">
              Unify data from all your favorite platforms (integrations
              launching soon)
            </p>
          </div>
          <div className="relative" data-id="element-220">
            {/* Left fade gradient */}
            <div className="absolute left-0 top-0 bottom-0 w-12 bg-gradient-to-r from-white to-transparent z-10" data-id="element-221"></div>
            {/* Right fade gradient */}
            <div className="absolute right-0 top-0 bottom-0 w-12 bg-gradient-to-l from-white to-transparent z-10" data-id="element-222"></div>
            {/* Logo slider container */}
            <div className="py-8 px-6 overflow-hidden" data-id="element-223">
              <div className="logo-slider flex items-center gap-12" data-id="element-224">
                {/* Logo 1 - Shopify */}
                <div className="logo-slide flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-225">
                  <img src="https://cdn.worldvectorlogo.com/logos/shopify.svg" alt="Shopify" className="h-8 w-auto object-contain" data-id="element-226" />
                </div>
                {/* Logo 2 - WooCommerce */}
                <div className="logo-slide flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-227">
                  <img src="https://cdn.worldvectorlogo.com/logos/woocommerce.svg" alt="WooCommerce" className="h-8 w-auto object-contain" data-id="element-228" />
                </div>
                {/* Logo 3 - Google Analytics */}
                <div className="logo-slide flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-229">
                  <img src="https://cdn.worldvectorlogo.com/logos/google-analytics-4.svg" alt="Google Analytics" className="h-8 w-auto object-contain" data-id="element-230" />
                </div>
                {/* Logo 4 - Klaviyo */}
                <div className="logo-slide flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-231">
                  <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/09/Klaviyo_idRlQDy2Ux_1.png" alt="Klaviyo" className="h-8 w-auto object-contain" data-id="element-232" />
                </div>
                {/* Logo 5 - Mailchimp */}
                <div className="logo-slide flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-233">
                  <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/mailchimp.svg" alt="Mailchimp" className="h-10 w-auto object-contain" data-id="element-234" />
                </div>
                {/* Logo 6 - BigCommerce */}
                <div className="logo-slide flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-235">
                  <img src="https://cdn.worldvectorlogo.com/logos/bigcommerce-1.svg" alt="BigCommerce" className="h-8 w-auto object-contain" data-id="element-236" />
                </div>
                {/* Logo 7 - Stripe */}
                <div className="logo-slide flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-237">
                  <img src="https://cdn.worldvectorlogo.com/logos/stripe-2.svg" alt="Stripe" className="h-8 w-auto object-contain" data-id="element-238" />
                </div>
                {/* Duplicate logos for continuous scrolling effect */}
                {/* Logo 1 - Shopify (duplicate) */}
                <div className="logo-slide flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-239">
                  <img src="https://cdn.worldvectorlogo.com/logos/shopify.svg" alt="Shopify" className="h-8 w-auto object-contain" data-id="element-240" />
                </div>
                {/* Logo 2 - WooCommerce (duplicate) */}
                <div className="logo-slide flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-241">
                  <img src="https://cdn.worldvectorlogo.com/logos/woocommerce.svg" alt="WooCommerce" className="h-8 w-auto object-contain" data-id="element-242" />
                </div>
                {/* Logo 3 - Google Analytics (duplicate) */}
                <div className="logo-slide flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-243">
                  <img src="https://cdn.worldvectorlogo.com/logos/google-analytics-4.svg" alt="Google Analytics" className="h-8 w-auto object-contain" data-id="element-244" />
                </div>
                {/* Logo 4 - Klaviyo (duplicate) */}
                <div className="logo-slide flex-shrink-0 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-245">
                  <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/09/Klaviyo_idRlQDy2Ux_1.png" alt="Klaviyo" className="h-8 w-auto object-contain" data-id="element-246" />
                </div>
              </div>
            </div>
          </div>
          <style jsx data-id="element-247">{`
            .logo-slider {
              animation: scroll 30s linear infinite;
              width: max-content;
            }
            @keyframes scroll {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(calc(-100% + 100vw));
              }
            }
            .logo-slide {
              min-width: 100px;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            @media (max-width: 640px) {
              .logo-slider {
                animation: scroll 20s linear infinite;
              }
              .logo-slide {
                min-width: 80px;
              }
            }
            .hide-scrollbar::-webkit-scrollbar {
              display: none;
            }
            .hide-scrollbar {
              -ms-overflow-style: none;
              scrollbar-width: none;
            }
            .question-slider {
              animation: slideQuestions 35s linear infinite;
            }
            @media (max-width: 1024px) {
              .question-slider {
                animation: slideQuestions 45s linear infinite;
              }
            }
            @media (max-width: 768px) {
              .question-slider {
                animation: slideQuestions 55s linear infinite;
              }
            }
            @media (max-width: 480px) {
              .question-slider {
                animation: slideQuestions 65s linear infinite;
              }
            }
            @keyframes slideQuestions {
              0% {
                transform: translateX(30%);
              }
              100% {
                transform: translateX(-100%);
              }
            }
          `}</style>
        </div>
        {/* Questions Slider Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12 relative z-10" data-id="element-248">
          <div className="text-center mb-8" data-id="element-249">
            <h3 className="text-2xl font-normal text-benetton-green mb-3 font-apercu" data-id="element-250">
              Ask Naiomi.ai Anything About Your eCommerce Business
            </h3>
            <p className="text-lg text-gray-600 font-medium font-jakarta" data-id="element-251">
              Get instant insights with natural language questions
            </p>
          </div>
          {/* Questions Slider */}
          <div className="relative overflow-hidden py-8" data-id="element-252">
            {/* Left fade gradient */}
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10" data-id="element-253"></div>
            {/* Right fade gradient */}
            <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10" data-id="element-254"></div>
            <div className="question-slider flex items-center gap-6 w-max" data-id="element-255">
              {/* Question 1 */}
              <div className="question-card flex-shrink-0 bg-white border border-gray-200 rounded-lg px-6 py-4 shadow-sm hover:shadow-md transition-all duration-300 max-w-md" data-id="element-256">
                <div className="flex items-start gap-3" data-id="element-257">
                  <div className="w-8 h-8 rounded-full bg-benetton-red flex items-center justify-center flex-shrink-0 mt-1" data-id="element-258">
                    <span className="text-white text-sm font-bold" data-id="element-259">Q</span>
                  </div>
                  <div data-id="element-260">
                    <p className="text-lg font-medium text-gray-800 mb-2" data-id="element-261">
                      What's my average customer lifetime value compared to last
                      year?
                    </p>
                    <div className="flex items-center" data-id="element-262">
                      <div className="w-6 h-6 rounded-full bg-benetton-green flex items-center justify-center" data-id="element-263">
                        <span className="text-white text-xs font-bold" data-id="element-264">AI</span>
                      </div>
                      <p className="text-sm text-gray-500 ml-2 italic" data-id="element-265">
                        Analyzing your customer data across platforms...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Question 2 */}
              <div className="question-card flex-shrink-0 bg-white border border-gray-200 rounded-lg px-6 py-4 shadow-sm hover:shadow-md transition-all duration-300 max-w-md" data-id="element-266">
                <div className="flex items-start gap-3" data-id="element-267">
                  <div className="w-8 h-8 rounded-full bg-benetton-orange flex items-center justify-center flex-shrink-0 mt-1" data-id="element-268">
                    <span className="text-white text-sm font-bold" data-id="element-269">Q</span>
                  </div>
                  <div data-id="element-270">
                    <p className="text-lg font-medium text-gray-800 mb-2" data-id="element-271">
                      Which marketing campaigns had the highest ROI last
                      quarter?
                    </p>
                    <div className="flex items-center" data-id="element-272">
                      <div className="w-6 h-6 rounded-full bg-benetton-green flex items-center justify-center" data-id="element-273">
                        <span className="text-white text-xs font-bold" data-id="element-274">AI</span>
                      </div>
                      <p className="text-sm text-gray-500 ml-2 italic" data-id="element-275">
                        Comparing campaign performance metrics...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Question 3 */}
              <div className="question-card flex-shrink-0 bg-white border border-gray-200 rounded-lg px-6 py-4 shadow-sm hover:shadow-md transition-all duration-300 max-w-md" data-id="element-276">
                <div className="flex items-start gap-3" data-id="element-277">
                  <div className="w-8 h-8 rounded-full bg-benetton-blue flex items-center justify-center flex-shrink-0 mt-1" data-id="element-278">
                    <span className="text-white text-sm font-bold" data-id="element-279">Q</span>
                  </div>
                  <div data-id="element-280">
                    <p className="text-lg font-medium text-gray-800 mb-2" data-id="element-281">
                      What products have the highest return rate and why?
                    </p>
                    <div className="flex items-center" data-id="element-282">
                      <div className="w-6 h-6 rounded-full bg-benetton-green flex items-center justify-center" data-id="element-283">
                        <span className="text-white text-xs font-bold" data-id="element-284">AI</span>
                      </div>
                      <p className="text-sm text-gray-500 ml-2 italic" data-id="element-285">
                        Investigating product return patterns...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Question 4 */}
              <div className="question-card flex-shrink-0 bg-white border border-gray-200 rounded-lg px-6 py-4 shadow-sm hover:shadow-md transition-all duration-300 max-w-md" data-id="element-286">
                <div className="flex items-start gap-3" data-id="element-287">
                  <div className="w-8 h-8 rounded-full bg-benetton-violet flex items-center justify-center flex-shrink-0 mt-1" data-id="element-288">
                    <span className="text-white text-sm font-bold" data-id="element-289">Q</span>
                  </div>
                  <div data-id="element-290">
                    <p className="text-lg font-medium text-gray-800 mb-2" data-id="element-291">
                      How is our email campaign performance trending this month?
                    </p>
                    <div className="flex items-center" data-id="element-292">
                      <div className="w-6 h-6 rounded-full bg-benetton-green flex items-center justify-center" data-id="element-293">
                        <span className="text-white text-xs font-bold" data-id="element-294">AI</span>
                      </div>
                      <p className="text-sm text-gray-500 ml-2 italic" data-id="element-295">
                        Analyzing email metrics from Klaviyo...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Question 5 */}
              <div className="question-card flex-shrink-0 bg-white border border-gray-200 rounded-lg px-6 py-4 shadow-sm hover:shadow-md transition-all duration-300 max-w-md" data-id="element-296">
                <div className="flex items-start gap-3" data-id="element-297">
                  <div className="w-8 h-8 rounded-full bg-benetton-yellow flex items-center justify-center flex-shrink-0 mt-1" data-id="element-298">
                    <span className="text-white text-sm font-bold" data-id="element-299">Q</span>
                  </div>
                  <div data-id="element-300">
                    <p className="text-lg font-medium text-gray-800 mb-2" data-id="element-301">
                      Which customer segments have grown the most this year?
                    </p>
                    <div className="flex items-center" data-id="element-302">
                      <div className="w-6 h-6 rounded-full bg-benetton-green flex items-center justify-center" data-id="element-303">
                        <span className="text-white text-xs font-bold" data-id="element-304">AI</span>
                      </div>
                      <p className="text-sm text-gray-500 ml-2 italic" data-id="element-305">
                        Comparing segment growth year-over-year...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Question 6 - New Subscription Question */}
              <div className="question-card flex-shrink-0 bg-white border border-gray-200 rounded-lg px-6 py-4 shadow-sm hover:shadow-md transition-all duration-300 max-w-md" data-id="element-306">
                <div className="flex items-start gap-3" data-id="element-307">
                  <div className="w-8 h-8 rounded-full bg-benetton-teal flex items-center justify-center flex-shrink-0 mt-1" data-id="element-308">
                    <span className="text-white text-sm font-bold" data-id="element-309">Q</span>
                  </div>
                  <div data-id="element-310">
                    <p className="text-lg font-medium text-gray-800 mb-2" data-id="element-311">
                      How has our subscription retention rate changed over the
                      past 3 months?
                    </p>
                    <div className="flex items-center" data-id="element-312">
                      <div className="w-6 h-6 rounded-full bg-benetton-green flex items-center justify-center" data-id="element-313">
                        <span className="text-white text-xs font-bold" data-id="element-314">AI</span>
                      </div>
                      <p className="text-sm text-gray-500 ml-2 italic" data-id="element-315">
                        Analyzing subscription data from ReCharge...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Question 7 - Gorgias Support + Subscriptions Question */}
              <div className="question-card flex-shrink-0 bg-white border border-gray-200 rounded-lg px-6 py-4 shadow-sm hover:shadow-md transition-all duration-300 max-w-md" data-id="element-316">
                <div className="flex items-start gap-3" data-id="element-317">
                  <div className="w-8 h-8 rounded-full bg-benetton-magenta flex items-center justify-center flex-shrink-0 mt-1" data-id="element-318">
                    <span className="text-white text-sm font-bold" data-id="element-319">Q</span>
                  </div>
                  <div data-id="element-320">
                    <p className="text-lg font-medium text-gray-800 mb-2" data-id="element-321">
                      What are the top support issues reported for subscription
                      products in Gorgias?
                    </p>
                    <div className="flex items-center" data-id="element-322">
                      <div className="w-6 h-6 rounded-full bg-benetton-green flex items-center justify-center" data-id="element-323">
                        <span className="text-white text-xs font-bold" data-id="element-324">AI</span>
                      </div>
                      <p className="text-sm text-gray-500 ml-2 italic" data-id="element-325">
                        Cross-analyzing Gorgias tickets with subscription
                        data...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Duplicates for continuous scrolling */}
              {/* Question 1 (duplicate) */}
              <div className="question-card flex-shrink-0 bg-white border border-gray-200 rounded-lg px-6 py-4 shadow-sm hover:shadow-md transition-all duration-300 max-w-md" data-id="element-326">
                <div className="flex items-start gap-3" data-id="element-327">
                  <div className="w-8 h-8 rounded-full bg-benetton-red flex items-center justify-center flex-shrink-0 mt-1" data-id="element-328">
                    <span className="text-white text-sm font-bold" data-id="element-329">Q</span>
                  </div>
                  <div data-id="element-330">
                    <p className="text-lg font-medium text-gray-800 mb-2" data-id="element-331">
                      What's my average customer lifetime value compared to last
                      year?
                    </p>
                    <div className="flex items-center" data-id="element-332">
                      <div className="w-6 h-6 rounded-full bg-benetton-green flex items-center justify-center" data-id="element-333">
                        <span className="text-white text-xs font-bold" data-id="element-334">AI</span>
                      </div>
                      <p className="text-sm text-gray-500 ml-2 italic" data-id="element-335">
                        Analyzing your customer data across platforms...
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
// Helper function to convert hex to rgba
function hexToRgba(hex: string, opacity: number): string {
  // Remove the hash if it exists
  hex = hex.replace('#', '');
  // Parse the hex values
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  // Return rgba value
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}